export const fondoJuego = {
  normal: 'h-full absolute w-full bg-[#272727]/50 -z-10 transition-all ease-in-out duration-300 ',
  jugando: 'h-full absolute w-full bg-[#272727] -z-10 transition-all ease-in-out duration-300'
}

export const formulario = {
  normal: 'hidden flex-col gap-6 items-center justify-center h-full',
  jugando: 'flex flex-col gap-6 items-center justify-center h-full '
}

//

export const modosJuegos = {
  normal: 'hidden flex-col h-full p-5',
  ventanaAbierta: 'flex flex-col h-full p-5',
  jugando: 'hidden flex-col h-full p-5'
}

export const ventFinal = {
  final: 'flex flex-col justify-center gap-20 h-full p-8',
  jugando: 'hidden flex-col justify-center gap-20 h-full p-8'
}

export const ventEstadist = {
  normal: 'hidden h-full',
  ventanaAbierta: 'h-full max-sm:w-full'
}

// responsive
export const barraLateral = {
  normal: 'bg-[#222222] border-r-2 border-r-white/35 w-1/5 p-2 flex flex-col justify-between max-sm:w-full max-lg:w-2/6',
  jugando: 'bg-[#222222] border-r-2 border-r-white/35 w-1/5 p-2 flex flex-col justify-between max-sm:w-full max-sm:hidden max-lg:w-2/6'
}

export const juego = {
  normal: 'w-4/5 relative max-sm:hidden max-sm:w-full max-lg:w-4/6',
  jugando: 'w-4/5 relative max-sm:w-full max-lg:w-4/6'
}
